module.exports = __webpack_public_path__ + "static/media/account.24d424e5.svg";